import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserInfo, UserInfo2 } from '../models/index';
import { ConnectedPositionStrategy } from '@angular/cdk/overlay';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '../services/loader.service';
import { FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';

import { COUNTRIES, Country } from '../data/countries';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatExpansionPanel,
  MatTabChangeEvent,
  MatSnackBar
} from '@angular/material';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageComponent implements OnInit {
  @ViewChild('payForm', { read: ElementRef })
  payForm: ElementRef;
  @ViewChild('matPanel', { read: MatExpansionPanel })
  matPanel: MatExpansionPanel;
  @ViewChild('addComps', { read: ElementRef })
  addComps: ElementRef;
  selected = new FormControl(0);
  edit = false;
  stripeCon = '';
  tempInfo: UserInfo2;
  isLoading = false;
  tempQty = 0;
  showCard = false;
  publishableKey = environment.publishableKey;
  stripeClientId = environment.stripeClientId;
  editSub = false;
  user: UserInfo = {
    rgID: '',
    hasStripeAccessToken: false,
    email: '',
    cardToken: null,
    stripeCustomerID: null,
    compQty: null,
    userInfo2: {
      firstName: '',
      lastName: '',
      country: '',
      addressLine1: '',
      addressLine2: '',
      zip: '',
      state: '',
      city: '',
      phone: ''
    },
    subscription: {
      Status: '',
      Start: '',
      Quantity: 0,
      EndedAt: '',
      TrialEnd: '',
      Created: '',
      CanceledAt: '',
      TrialStart: '',
      TrialPeriodDays: '',
      CancelAtPeriodEnd: '',
      CurrentPeriodStart: '',
      CurrentPeriodEnd: '',
      last4: '',
      zip: ''
    }
  };

  countries = COUNTRIES;
  regions;

  panelOpenState = false;
  stripe = Stripe(this.publishableKey);
  elements = this.stripe.elements();
  subEdit = false;
  editCard = false;

  style = {
    base: {
      color: '#32325d',
      lineHeight: '18px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };
  click = false;
  userFormGroup: FormGroup;
  card = this.elements.create('card', { style: this.style });
  constructor(
    private router: Router,
    private authService: AuthService,
    private loader: LoaderService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {}

  saveCustomer() {
    if (this.userFormGroup.invalid) {
      console.log('invalid');
      return;
    }
    this.user.userInfo2 = this.userFormGroup.value;
    this.authService.saveCustomer(this.user).subscribe(
      data => {
        this.saveSuccess(data);
      },
      error => console.log(error)
    );
  }

  saveSuccess(user: UserInfo) {
    this.userFormGroup.patchValue(this.user.userInfo2);
    this.openSnackBar();
  }

  createCustomer() {
    this.authService
      .createStripeCustomer(this.user)
      .subscribe(data => console.log(data), error => console.log(error));
  }

  ngOnInit() {
    this.userFormGroup = this.formBuilder.group({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      zip: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required)
    });
    this.loader.loadingChange.subscribe(load => (this.isLoading = load));
    const currUser = localStorage.getItem('currentUser');

    if (JSON.parse(currUser)) {
      const userToken = JSON.parse(localStorage.getItem('currentUser')).token;
      const payload = atob(userToken.split('.')[1]);
      const expDate = JSON.parse(payload).exp;
      const d = new Date(0);
      d.setUTCSeconds(+expDate);
      if (d < new Date()) {
        this.authService.logout();
        this.router.navigateByUrl('/login');
      }
    } else {
      this.authService.logout();
      this.router.navigateByUrl('/login');
    }
    this.authService.getUserInfo().subscribe(
      user => {
        this.success(user);
      },
      error => {
        this.authService.logout();
        this.router.navigateByUrl('/login');
      }
    );
  }

  openSnackBar() {
    this.snackBar.openFromComponent(SnackBarMessageComponent, {
      duration: 500
    });
  }

  createElements() {
    this.showCard = true;

    const elements = this.stripe.elements();

    this.card.mount('#card-element');
  }

  async createCardToken() {
    if (!this.click) {
      this.click = true;
      const { token, error } = await this.stripe.createToken(this.card);

      if (error) {
        // Inform the customer that there was an error.
        const errorElement = document.getElementById('card-errors');
        errorElement.textContent = error.message;
        this.click = false;
      } else {
        // Send the token to your server.
        // stripeTokenHandler(token);
        this.user.cardToken = token;
        this.user.cardToken.card.metadata = '';

        if (!this.editCard) {
          this.user.subscription.Quantity = this.tempQty + 1;
          this.authService
            .createStripeCustomer(this.user)
            .subscribe(data => (this.user = data), err => this.cardError(err));
        } else {
          this.authService
            .updateCard(this.user)
            .subscribe(data => this.updateCardSuccess(data), err => console.log(err));
        }
      }
    }
  }

  cardError(err) {
    const errorElement = document.getElementById('card-errors');
    errorElement.textContent = err;
  }

  updateCardSuccess(data: UserInfo) {
    this.user = data;
    this.editCard = false;
    this.panelOpenState = false;
    this.matPanel.close();
  }

  editSubscription() {
    this.editSub = true;
    this.tempQty = this.user.subscription.Quantity - 1;
  }

  tabChanged(event: MatTabChangeEvent) {
    if (event.index === 2 && !this.user.subscription.Status) {
      this.addComps.nativeElement.focus();
    }
    this.editCard = false;
    this.editSub = false;
    this.subEdit = false;
  }

  success(user: UserInfo) {
    this.userFormGroup.patchValue(user.userInfo2);

    this.user = user;

    if (this.user.hasStripeAccessToken === true) {
      this.stripeCon = 'Stripe Account Connected!';
    } else {
      this.stripeCon = null;
    }

    const index = this.countries.findIndex(function(item, i) {
      return item.countryValue === user.userInfo2.country;
    });
    this.regions = this.countries[index].regions;

  }
  updateSubscription() {
    this.user.subscription.Quantity = this.tempQty + 1;
    this.authService
      .updateSubscription(this.user)
      .subscribe(user => this.updateSubSuccess(user), error => console.log(error));
  }

  updateSubSuccess(user: UserInfo) {
    this.user = user;
    this.editSub = false;
  }

  restartSubscription() {
    this.user.subscription.CancelAtPeriodEnd = 'false';
    this.authService
      .restartSubscription(this.user)
      .subscribe(user => this.updateSubSuccess(user), error => console.log(error));
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ManageDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.user.subscription.CancelAtPeriodEnd = 'true';
        this.updateSubscription();
      }
    });
  }

  onChange(ev) {
    this.userFormGroup.controls['state'].setValue('');
    this.userFormGroup.controls['state'].markAsUntouched();
    const index = this.countries.findIndex(function(item, i) {
      return item.countryValue === ev.value;
    });
    this.regions = this.countries[index].regions;
  }


  get firstName() {
    return this.userFormGroup.get('firstName');
  }
  get lastName() {
    return this.userFormGroup.get('lastName');
  }
  get country() {
    return this.userFormGroup.get('country');
  }
  get addressLine1() {
    return this.userFormGroup.get('addressLine1');
  }
  get addressLine2() {
    return this.userFormGroup.get('addressLine2');
  }
  get zip() {
    return this.userFormGroup.get('zip');
  }
  get state() {
    return this.userFormGroup.get('state');
  }
  get city() {
    return this.userFormGroup.get('city');
  }
  get phone() {
    return this.userFormGroup.get('phone');
  }
}

@Component({
  selector: 'app-manage-dialog',
  templateUrl: './manage-dialog.html',
  styleUrls: ['./manage.component.css']
})
export class ManageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ManageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boolean
  ) {}

  confirm(result: boolean) {
    this.data = result;
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'app-snack-bar',
  template: '<span class="center">Saved Successfully</span>',
  styles: ['./manage.component.css']
})
export class SnackBarMessageComponent {}



// UPDATE [Saddle Options Type] SET SalesOrder = 0
// WHERE ID = 1
// UPDATE [Saddle Options Type] SET SalesOrder = 5
// WHERE ID = 2
// UPDATE [Saddle Options Type] SET SalesOrder = 10
// WHERE ID = 4
// UPDATE [Saddle Options Type] SET SalesOrder = 15
// WHERE ID = 3
// UPDATE [Saddle Options Type] SET SalesOrder = 20
// WHERE ID = 35
// UPDATE [Saddle Options Type] SET SalesOrder = 25
// WHERE ID = 72
// UPDATE [Saddle Options Type] SET SalesOrder = 30
// WHERE ID = 5
// UPDATE [Saddle Options Type] SET SalesOrder = 35
// WHERE ID = 6
// UPDATE [Saddle Options Type] SET SalesOrder = 40
// WHERE ID = 7
// UPDATE [Saddle Options Type] SET SalesOrder = 45
// WHERE ID = 8
// UPDATE [Saddle Options Type] SET SalesOrder = 50
// WHERE ID = 68
// UPDATE [Saddle Options Type] SET SalesOrder = 55
// WHERE ID = 15
// UPDATE [Saddle Options Type] SET SalesOrder = 60
// WHERE ID = 73
// UPDATE [Saddle Options Type] SET SalesOrder = 65
// WHERE ID = 79
// UPDATE [Saddle Options Type] SET SalesOrder = 70
// WHERE ID = 9
// UPDATE [Saddle Options Type] SET SalesOrder = 75
// WHERE ID = 19
// UPDATE [Saddle Options Type] SET SalesOrder = 80
// WHERE ID = 20
// UPDATE [Saddle Options Type] SET SalesOrder = 85
// WHERE ID = 21
// UPDATE [Saddle Options Type] SET SalesOrder = 90
// WHERE ID = 49
// UPDATE [Saddle Options Type] SET SalesOrder = 95
// WHERE ID = 22
// UPDATE [Saddle Options Type] SET SalesOrder = 100
// WHERE ID = 59
// UPDATE [Saddle Options Type] SET SalesOrder = 105
// WHERE ID = 62
// UPDATE [Saddle Options Type] SET SalesOrder = 110
// WHERE ID = 60
// UPDATE [Saddle Options Type] SET SalesOrder = 115
// WHERE ID = 63
// UPDATE [Saddle Options Type] SET SalesOrder = 120
// WHERE ID = 61
// UPDATE [Saddle Options Type] SET SalesOrder = 125
// WHERE ID = 64
// UPDATE [Saddle Options Type] SET SalesOrder = 130
// WHERE ID = 10
// UPDATE [Saddle Options Type] SET SalesOrder = 135
// WHERE ID = 11
// UPDATE [Saddle Options Type] SET SalesOrder = 140
// WHERE ID = 12
// UPDATE [Saddle Options Type] SET SalesOrder = 145
// WHERE ID = 54
// UPDATE [Saddle Options Type] SET SalesOrder = 150
// WHERE ID = 32
// UPDATE [Saddle Options Type] SET SalesOrder = 155
// WHERE ID = 56
// UPDATE [Saddle Options Type] SET SalesOrder = 160
// WHERE ID = 13
// UPDATE [Saddle Options Type] SET SalesOrder = 165
// WHERE ID = 14
// UPDATE [Saddle Options Type] SET SalesOrder = 170
// WHERE ID = 16
// UPDATE [Saddle Options Type] SET SalesOrder = 175
// WHERE ID = 17
// UPDATE [Saddle Options Type] SET SalesOrder = 180
// WHERE ID = 27
// UPDATE [Saddle Options Type] SET SalesOrder = 185
// WHERE ID = 28
// UPDATE [Saddle Options Type] SET SalesOrder = 190
// WHERE ID = 65
// UPDATE [Saddle Options Type] SET SalesOrder = 195
// WHERE ID = 41
// UPDATE [Saddle Options Type] SET SalesOrder = 200
// WHERE ID = 31
// UPDATE [Saddle Options Type] SET SalesOrder = 205
// WHERE ID = 80
// UPDATE [Saddle Options Type] SET SalesOrder = 210
// WHERE ID = 37
// UPDATE [Saddle Options Type] SET SalesOrder = 215
// WHERE ID = 42
// UPDATE [Saddle Options Type] SET SalesOrder = 220
// WHERE ID = 34
// UPDATE [Saddle Options Type] SET SalesOrder = 225
// WHERE ID = 40
// UPDATE [Saddle Options Type] SET SalesOrder = 230
// WHERE ID = 18
